module.exports = __webpack_public_path__ + "img/icons_14.ea7dccbb.png";